import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { LOGO_URL } from "../lib/api";

const links = [
  { to: "/", label: "Home" },
  { to: "/recipes", label: "Recipes" },
  { to: "/blogs", label: "Blogs" },
  { to: "/contact", label: "Contact" },
];

export default function Navbar({ onEnquire }) {
  const [open, setOpen] = useState(false);
  return (
    <header className="sticky top-0 z-40 bg-[#FCFAF8]/90 backdrop-blur-xl border-b border-[#E5E0D8]" data-testid="navbar">
      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-16 h-28 md:h-32 relative flex items-center">
        <Link to="/" className="flex items-center mx-auto md:mx-0" data-testid="navbar-logo">
          <img
            src={LOGO_URL}
            alt="I'm Ube — Pure Natural Vibrant"
            className="h-24 md:h-28 w-auto object-contain"
          />
        </Link>
        <nav className="hidden md:flex items-center gap-10 ml-auto">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === "/"}
              data-testid={`nav-${l.label.toLowerCase()}`}
              className={({ isActive }) =>
                `text-sm tracking-wide transition-colors ${isActive ? "text-[#4B0082] font-medium" : "text-[#1A1A1A] hover:text-[#4B0082]"}`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>
        <div className="hidden md:block ml-10">
          <button onClick={() => onEnquire?.()} className="btn-primary" data-testid="navbar-enquire-btn">
            Enquire Bulk
          </button>
        </div>
        <button
          className="md:hidden absolute right-6 top-1/2 -translate-y-1/2 text-[#4B0082]"
          onClick={() => setOpen(!open)}
          aria-label="Menu"
          data-testid="navbar-mobile-toggle"
        >
          {open ? <X /> : <Menu />}
        </button>
      </div>
      {open && (
        <div className="md:hidden bg-[#FCFAF8] border-t border-[#E5E0D8] px-6 py-6 space-y-4" data-testid="navbar-mobile-menu">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === "/"}
              onClick={() => setOpen(false)}
              className="block text-base text-[#1A1A1A]"
              data-testid={`mobile-nav-${l.label.toLowerCase()}`}
            >
              {l.label}
            </NavLink>
          ))}
          <button
            onClick={() => { setOpen(false); onEnquire?.(); }}
            className="btn-primary w-full justify-center"
            data-testid="mobile-navbar-enquire-btn"
          >
            Enquire Bulk
          </button>
        </div>
      )}
    </header>
  );
}
